import * as React from 'react'
import { connect } from 'react-redux'

import { applicationFieldChanged } from 'common/actions/application'
import { Application, Field } from 'embed/constants'
import { MultiProductState } from 'embed/reducers'
import { applicationMortgageSelector } from 'embed/selectors/application'
import { Product } from 'even-ts-static'
import ApplicationView from './index'

interface Props {
  application: Application
  dispatchApplicationFieldChanged: (field: Field, value: unknown) => void
}

const ApplicationContainer: React.FC<Props> = ({ application, dispatchApplicationFieldChanged }) => {
  const onChange = React.useCallback(
    (field: Field, value) => {
      dispatchApplicationFieldChanged(field, value)
    },
    [dispatchApplicationFieldChanged],
  )

  return <ApplicationView onChange={onChange} application={application} />
}

const mapStateToProps = (state: MultiProductState) => ({
  application: applicationMortgageSelector(state),
})

const mapDispatchToProps = (dispatch) => ({
  dispatchApplicationFieldChanged: (field: Field, value) =>
    dispatch(applicationFieldChanged(Product.Mortgage, field.key, value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationContainer)
